import '.d{display:flex;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.a6{gap:0.5rem;}.ssr-plugin'
import '.ad{cursor:pointer;}.ssr-plugin'
import '.cu{padding:0.75rem;}.ssr-plugin'
import '.ah{border-radius:1.25rem;}.ssr-plugin'
import '.a8{border:var(--border-subtle);}.ssr-plugin'
import '.a7{background-color:var(--palette-white);}.ssr-plugin'
import '.de{transition:background-color 0.2s ease;}.ssr-plugin'
import '.du{width:2.5rem;}.ssr-plugin'
import '.dv{height:2.5rem;}.ssr-plugin'
import '.hc{color:var(--palette-blue-700);}.ssr-plugin'
import '.hd{font-size:0.9rem;}.ssr-plugin'
import '.ap{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="d i e f a6 ad cu ah a8 a7 de"
        style={{
          '&:hover': {
            backgroundColor: 'var(--palette-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="du dv d f i hc"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="hd hc ap"
        >
          {label}
        </span>
      </styled.button>
    )
}